import { Box, Grid } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { ReactComponent as AccountArrowsIcon } from 'img/ptStock.svg'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { INVENTORY_STEPS } from 'shared'
import { useCardmarketConnect } from '../cardmarket'
import { SquareButton } from './SquareButton'

interface ConnectAccountProps {
  handleImportStock: () => Promise<void>
}

export const ConnectAccount = ({ handleImportStock }: ConnectAccountProps): JSX.Element => {
  const { t } = useTranslation()
  const { user } = useUser()
  const [connectCardmarketAccount, Popup, loading] = useCardmarketConnect()
  const setStep = useInventoryStore((state) => state.setStep)
  const [loadingStock, setLoadingStock] = useState<boolean>(false)

  const isFirstImport = user?.ptInventory?.lastManualSyncWithCardmarketAt === null

  const onConnect = () => {
    if (!loadingStock) {
      setLoadingStock(true)
      console.log(`importing stock`)
      handleImportStock().then(() => {
        console.log(`finished importing stock`)
        setStep(INVENTORY_STEPS.STOCK_REVIEW.idx)
        setLoadingStock(false)
      })
    }
  }

  useEffect(() => {
    if (user.cardmarketUsername) {
      onConnect()
    }
  }, [user.cardmarketUsername])

  return (
    <>
      <Box>
        <Box className="title">
          <div className="titleFont">
            {isFirstImport
              ? t('ptInventory.connectAccount.title.firstTimeImport')
              : t('ptInventory.connectAccount.title.notFirstTimeImport')}
          </div>
        </Box>
        <Box marginY={5} />
        <Box marginY={2}>
          <div className="bodyFont">
            {isFirstImport
              ? t('ptInventory.connectAccount.text1.firstTimeImport')
              : t('ptInventory.connectAccount.text1.notFirstTimeImport')}
          </div>
        </Box>
        <Box marginY={5} />

        <Grid container className="gridContainer">
          <Grid item xs={12}>
            <SquareButton
              image={<AccountArrowsIcon />}
              text={
                loading
                  ? t('connectCardmarket.connecting')
                  : t('ptInventory.connectAccount.connect')
              }
              type="primary"
              handleClick={() => connectCardmarketAccount()}
            />
          </Grid>
        </Grid>
        <Popup />
      </Box>
    </>
  )
}
